module.exports = __webpack_public_path__ + "img/con_12.4142ec6d.svg";